export default function About() {
    return (
        <section id="about" className="px-6 py-24 bg-[#161b22]" data-aos="fade-up">
            <div className="max-w-3xl mx-auto">
                <p className="text-[#f0883e] text-xs mb-2 font-mono tracking-widest uppercase">
                    {'// about_me.md'}
                </p>
                <h2 className="text-2xl font-bold text-[#e6edf3] mb-8 font-mono">About</h2>

                <div className="bg-[#0d1117] border border-[#30363d] rounded-lg p-6 hover:border-[#3fb950]/40 transition-colors duration-300">
                    <div className="flex items-center gap-2 mb-4 pb-3 border-b border-[#30363d]">
                        <span className="text-[#58a6ff] text-xs font-mono">about_me.md</span>
                        <span className="ml-auto text-[#3fb950] text-xs font-mono">● markdown</span>
                    </div>
                    <p className="text-[#8b949e] text-sm leading-7 font-mono">
                        I'm a Software Engineer with a focus on backend systems, infrastructure,
                        firmware, and interfaces. I currently work at Mujin, where I get to build
                        reliable and high-performance software every day. I earned my Master's degree
                        in Computer Science from Northeastern University, and over the years, I've
                        worked on everything from production-grade firmware in C++ to scalable backend
                        APIs and distributed infrastructure. I enjoy deep system-level work and take
                        pride in writing clean, well-architected code that just works.
                    </p>
                </div>
            </div>
        </section>
    );
}
